<template>
    <div class="loading-container">
        <loading :active="loading" :is-full-page="false" />

        <template v-if="!loading">
            <div class="task-body">
                <JobLink :companyId="role.companyId" :executiveId="role.executiveId" />

                <h2>Job Role Ended</h2>

                <dl>
                    <dt>Confirmed Date</dt>
                    <dd>{{ jobHistoryConfirmedDate }}</dd>
                    <dt>Company Name</dt>
                    <dd>{{ company.name }}</dd>
                    <dt>Role</dt>
                    <dd>{{ role.role }}</dd>
                </dl>

                <form @submit.prevent>
                    <mt-input
                        type="date"
                        v-model="role.startDate"
                        label="Start Date"
                        @update:modelValue="markChanged"
                    />
                    <mt-input type="date" v-model="role.endDate" label="End Date" @update:modelValue="markChanged" />
                    <mt-checkbox v-model="role.active" label="Active" @update:modelValue="markChanged" />
                </form>

                <InputError :errorMessage="errors" />
            </div>
            <div class="task-actions">
                <button @click="completeTask" class="primary">Complete</button>
            </div>
        </template>
    </div>
</template>

<script>
import TaskService from '@/services/manage/taskService'
import InputError from '@/components/shared/forms/input-error'
import CompanyService from '@/services/manage/companyService'
import { JobRolesService } from '@/services/manage/JobRolesService'
import JobLink from '@/components/manage/tasks/Jobs/JobLink'
import { Status } from '@/utils/request'
import ExecutiveService from '@/services/manage/executiveService'

export default {
    components: { JobLink, InputError },
    props: {
        task: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            changed: false,
            errors: [],
        }
    },
    computed: {
        executiveId() {
            return this.task.primaryEntityId
        },
        roleId() {
            return this.task.secondaryEntityId
        },
        loading() {
            return (
                this.$asyncComputed.company.updating ||
                this.$asyncComputed.role.updating ||
                this.$asyncComputed.jobHistoryConfirmedDate.updating
            )
        },
    },
    asyncComputed: {
        company: {
            async get() {
                if (this.role?.companyId) {
                    return await CompanyService.get(this.role.companyId)
                }

                return {}
            },
            default() {
                return {}
            },
        },
        jobHistoryConfirmedDate: {
            async get() {
                return await ExecutiveService.getJobHistoryConfirmedDate(this.executiveId)
            },
            default: null,
        },
        role: {
            async get() {
                let role = await JobRolesService.get(this.roleId)

                return {
                    ...role,
                    startDate: role.startDate?.substring(0, 10),
                    endDate: role.endDate?.substring(0, 10),
                }
            },
            default() {
                return {}
            },
        },
    },

    methods: {
        markChanged() {
            this.changed = true
        },
        async completeTask() {
            if (this.changed) {
                let { ok, status, content } = await JobRolesService.update(this.roleId, this.role)

                if (!ok) {
                    if (status === Status.UNPROCESSABLE_ENTITY) {
                        this.$flash('An error occurred when updating this job role.', 'error')
                        this.errors = Object.values(content).flat()
                    } else {
                        this.$flash('An unknown error occurred when updating this job role.', 'error')
                    }

                    return
                }
            }

            await TaskService.complete(this.task)
            this.$flash('Job role updated successfully.', 'success')
        },
    },
}
</script>
